import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { ExternalRequest, PaymentsApi, PostRequisitesResponse } from '@shared/api/rest/payments';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface ExternalType {
  data?: PostRequisitesResponse;
  loading: boolean;
  error: string | null;
  success: boolean | null;
  post: (request: ExternalRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useExternalStore = create<ExternalType>((set) => ({
  data: undefined,
  loading: false,
  error: null,
  success: null,

  post: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await PaymentsApi.external(request, signal);
      set({ data: result?.data ?? [], loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: undefined, loading: false, error: null, success: null }),
}));
